import React, {Component} from 'react';

// Components
import BrowserThumb from '../../components/BrowserThumb/BrowserThumb';

// Data
import Data from '../../data/Themes.json';

class Themes extends Component {
    render () {

        const limit = this.props.limit;
        const exclude = this.props.exclude;
        let themes = Data.themes;

        if ( exclude !== '' && exclude !== undefined ) {
        	themes = themes.filter(function(theme) {
				if (theme.theme === exclude) {
					return false; // skip
				}
					return true;
			});
    	}
	  	if ( limit !== '-1' ) {
            themes = themes.slice(0, limit);
        }

        return (
            <div className={ `themes ${this.props.classes}` } >
                <h4 className="heading">{this.props.title}</h4>

                <div className="row">
                	{
	                	themes.map((theme, i) => {
							return (
								<div key={i} className={this.props.grid}>
									<BrowserThumb 
                                        title={theme.theme} 
                                        link={theme.path} 
                                        src={theme.thumb}
                                        srcLow={theme.thumbLow}
                                        imageAlt={theme.theme}
                                        bgColor="#000000"
                                        width="765"
                                        height="529" 
                                        classes=""
                                    />
								</div>
							);
						})
                	}
                </div>
            </div>
        );
    }
}

export default Themes;


// WEBPACK FOOTER //
// ./src/containers/Themes/Themes.js